import { TypedDocumentNode } from '@graphql-typed-document-node/core'
import { print } from 'graphql'
import { WithDeleted } from 'rxdb'

type Model = {
  rowId: string
  updatedAt?: string
}

export const pullResponseModifier = <T extends Model>(
  data: {
    nodes: Array<WithDeleted<T>>
  },
  mapper?: (nodes: Array<WithDeleted<T>>) => Array<WithDeleted<T>>
) => {
  const lastNode = data?.nodes?.[data?.nodes.length - 1]
  return {
    documents:
      typeof mapper === 'function'
        ? mapper(data?.nodes || [])
        : data?.nodes || [],
    checkpoint: lastNode
      ? {
          rowId: lastNode?.rowId,
          updatedAt: lastNode?.updatedAt,
        }
      : null,
  }
}

export const createQueryWithHash = <R, T>(
  document: TypedDocumentNode<R, T>
) => {
  const hash = document.__meta__.hash

  return {
    query: print(document),
    extensions: {
      persistedQuery: {
        version: 1,
        sha256Hash: hash,
      },
    },
  }
}
